import { VehiclesCanHistoryMessages, TranslationVehiclesCanHistoryMessages } from "../interfaces";

export const messages: TranslationVehiclesCanHistoryMessages = {
  [VehiclesCanHistoryMessages.title]: "Historial de vehículos - CAN",
  [VehiclesCanHistoryMessages.generalHistory]: "Historial general",
  [VehiclesCanHistoryMessages.historyByEquipment]: "Historial por Vehículo",
  [VehiclesCanHistoryMessages.equipment]: "Vehículo",
  [VehiclesCanHistoryMessages.travels]: "Cant. Viajes",
  [VehiclesCanHistoryMessages.engineRuntime]: "Tiempo Motor Encendido (h:mm)",
  [VehiclesCanHistoryMessages.idleEngineHours]: "Marcha Lenta (h:mm)",
  [VehiclesCanHistoryMessages.kmTraveled]: "Total Distancia Recorrida (km)",
  [VehiclesCanHistoryMessages.speedingAlerts]: "Alerta Velocidad Excedida",
  [VehiclesCanHistoryMessages.licensePlate]: "Placa",
  [VehiclesCanHistoryMessages.fuelConsumption]: "Consumo Total Combustible (L)",
  [VehiclesCanHistoryMessages.idleFuelConsumption]: "Consumo Marcha Lenta (L)",
  [VehiclesCanHistoryMessages.avgFuelConsumption]: "Consumo Promedio en Movimiento (km/L)",
  [VehiclesCanHistoryMessages.litersPerHour]: "Consumo por Hora Motor (L/h)",
  [VehiclesCanHistoryMessages.litersPerM3]: "Consumo por m³ (L/m³)",
  [VehiclesCanHistoryMessages.litersPerTravel]: "Consumo por Viaje (L)",
  [VehiclesCanHistoryMessages.idleLitersPerHour]: "Consumo Marcha Lenta por Hora (L/h)",
  [VehiclesCanHistoryMessages.fuelingAlerts]: "Alerta Variación Combustible (+)",
  [VehiclesCanHistoryMessages.suddenDropAlerts]: "Alerta Variación Combustible (-)",
  [VehiclesCanHistoryMessages.highTemperatureAlerts]: "Alerta Temperatura Elevada",
  [VehiclesCanHistoryMessages.vehicleType]: "Tipo de Vehículo",
  [VehiclesCanHistoryMessages.vehicles]: "Cant. Vehículos"
};
